<template>
    <u-inline-group>
        <li v-for="info in infos" :key="info.title" :class="info.clear == true ? 'clear' : ''">
            <u-txt-default class="txt--xs white--text">
                {{ info.title }} <span class="grey--text text--lighten-1">{{ info.text }}</span>
            </u-txt-default>
        </li>
    </u-inline-group>
</template>

<script>
import UInlineGroup from "@/components/publish/styles/groups/u-inline-group.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";

export default {
    props: {},
    components: {
        UInlineGroup,
        UTxtDefault,
    },
    data() {
        return {
            infos: [
                { title: "대표", text: "김기홍" },
                { title: "이메일", text: "thepodium830@naver.com" },
                { title: "연락처", text: "02-6239-0330" },
                { title: "사업자번호", text: "476-81-02053" },
                { title: "주소", text: "경기도 오산시 원동로37번길 46, 5층(원동, 롯데시네마오산)", clear: true },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
